import React, {Component} from 'react';


import LayoutComponent from '../Components/Layout'

export default class NotFound extends Component {
    render() {
        console.log('this.propsthis.props',this.props)
        return (
            <LayoutComponent logoUrl="/" {...this.props}>
                <div className="not-found">
                    We know you’re looking for water, But sorry dude, this is a <strong>desert!</strong>
                </div>
            </LayoutComponent>

        )
    }
}

